import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { TCorePage, TStatusExtraData } from "../../Types";
import { post } from "../axios-post";

export const apiCallWarnReport = async ({
  reportId,
  reportedUUID,
  TBW_ids,
  pageName
}: {
  reportId: number;
  reportedUUID: string;
  TBW_ids: number[];
  pageName: TCorePage;
}): Promise<{
  data: Ti18nKeys;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    type: "resolve" | "email";
    reportId: number;
    reportedId: number;
  }>("reports/warnReport", {
    reportId,
    reportedUUID,
    pageName,
    TBW_ids
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: "OK",
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: "ERROR",
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: "ERROR",
      status: "ERROR",
      code: "ERROR"
    };
  }
};
export const apiCallBanReport = async ({
  reportId,
  reportedUUID,
  type,
  extraData,
  pageName
}: {
  reportId: number;
  reportedUUID: string;
  type: string;
  extraData: TStatusExtraData;
  pageName: TCorePage;
}): Promise<{
  data: Ti18nKeys;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    type: "resolve" | "email";
    reportId: number;
    reportedId: number;
  }>("reports/banReport", {
    reportId,
    reportedUUID,
    type,
    pageName,
    extraData
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: "OK",
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: "ERROR",
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: "ERROR",
      status: "ERROR",
      code: "ERROR"
    };
  }
};

export const apiCallResolveReport = async ({
  reportId,
  reportedId,
  type
}: {
  reportId: number;
  reportedId: number;
  type: string;
}): Promise<{
  data: Ti18nKeys;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    type: "resolve" | "email";
    reportId: number;
    reportedId: number;
  }>("reports/resolveReport", {
    type,
    reportId,
    reportedId
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: "OK",
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: "ERROR",
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: "ERROR",
      status: "ERROR",
      code: "ERROR"
    };
  }
};
